import { serviceHost } from '../../common/const';
import ServiceRequest from '../../utils/service-request';

export const getTaxIds = async (id) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/kyc/taxId/getTaxIds/' + id);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}

export const saveTaxIds = async (data) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/kyc/taxId/saveTaxIds', data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}

export const getClientInfo = async (clientId) => {
    try {
        let data = { clientId }
        let response = await ServiceRequest('post', 'json', serviceHost + '/kyc/taxId/getTaxIdData', data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}
